import React from "react";

import { StationProvisioning } from "../../../../hooks/useStationProvisioning";
import { JourneyStep } from "../../../../types/onboarding";
import { StationSetup, withStationSetup } from "../../../../utils/stationSetup";
import EroundProvisioningSection from "./EroundProvisioningSection";
import JourneyProgress from "./JourneyProgress";

interface EroundJourneyProps {
  stationIds: string[];
  steps: JourneyStep[];
  // "Access data & eRound", worked out once by the page for this and the
  // next-step bar alike.
  setup: StationSetup;
  provisioning: { byStation: Record<string, StationProvisioning>; reload: () => Promise<unknown> | void };
  nextAction: string | null;
  ended: boolean;
}

/**
 * The onboarding journey with access data and eRound as one step, and the
 * per-station eRound table below it (SOPS-148).
 */
const EroundJourney: React.FC<EroundJourneyProps> = ({ stationIds, steps, setup, provisioning, nextAction, ended }) => (
  <>
    <JourneyProgress steps={withStationSetup(steps, setup)} nextAction={nextAction} ended={ended} />
    <EroundProvisioningSection stationIds={stationIds} provisioning={provisioning} />
  </>
);

export default EroundJourney;
